export default "__VITE_ASSET__BaegoUe$__"